import {
  entityImagesDetailed,
  type ModerationEntity,
  type Translate,
} from '@/entities/moderation';
import { PreviewableImage } from './image-preview';

const MAX_PHOTOS = 8;

export function PhotosSection({
  entity,
  t,
  placeholder = false,
}: {
  entity: ModerationEntity;
  t: Translate;
  /** Keeps the block (with a «—») when there are no photos, for aligned compare columns. */
  placeholder?: boolean;
}) {
  const images = entityImagesDetailed(entity).slice(0, MAX_PHOTOS);
  if (images.length === 0) {
    if (!placeholder) return null;
    return (
      <div>
        <h4 className="text-[14px] leading-[normal] font-semibold tracking-[-0.28px] text-black dark:text-foreground">
          {t('detail.photos', 'Фотографии')}
        </h4>
        <p className="mt-3 text-sm text-muted-foreground">—</p>
      </div>
    );
  }

  return (
    <div>
      <h4 className="text-[14px] leading-[normal] font-semibold tracking-[-0.28px] text-black dark:text-foreground">
        {t('detail.photos', 'Фотографии')}
      </h4>
      <div className="mt-3 grid grid-cols-4 gap-2">
        {images.map((image, index) => (
          <PreviewableImage
            key={`${image.url}-${index}`}
            src={image.url}
            className="aspect-square w-full rounded-lg object-cover"
          />
        ))}
      </div>
    </div>
  );
}
